import React from 'react';
import { authenticationService, organizationService, organizationUserService } from '@/_services';
import { Header } from '@/_components';
import { toast } from 'react-hot-toast';
import ReactTooltip from 'react-tooltip';
import { whitelistService } from '../_services/whitelist.service';

class ManageWhitelist extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentUser: authenticationService.currentUserValue,
      isLoading: true,
      showAddIpForm: false,
      addingIp: false,
      editingIp: false,
      editingId: 0,
      newIp: {},
      removingIp: null,
      restoringIp: null,
      fields: {
        ip: '',
        comment: '',
      },
      errors: {},
    };

    this.tableRef = React.createRef();
  }

  validateIp(ip) {
    const re =
      /(?:^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}\/(\d{2})$)|(?:^(?:(?:[a-fA-F\d]{1,4}:){7}(?:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){6}(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){5}(?::(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,2}|:)|(?:[a-fA-F\d]{1,4}:){4}(?:(?::[a-fA-F\d]{1,4}){0,1}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,3}|:)|(?:[a-fA-F\d]{1,4}:){3}(?:(?::[a-fA-F\d]{1,4}){0,2}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,4}|:)|(?:[a-fA-F\d]{1,4}:){2}(?:(?::[a-fA-F\d]{1,4}){0,3}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,5}|:)|(?:[a-fA-F\d]{1,4}:){1}(?:(?::[a-fA-F\d]{1,4}){0,4}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,6}|:)|(?::(?:(?::[a-fA-F\d]{1,4}){0,5}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,7}|:)))(?:%[0-9a-zA-Z]{1,})?\/(\d{2,3})$)/gm;
    return re.test(String(ip));
  }

  handleValidation() {
    let fields = this.state.fields;
    let errors = {};

    if (!fields['ip']) {
      errors['ip'] = 'This field is required';
    } else if (!this.validateIp(fields['ip'])) {
      errors['ip'] = 'IP is not valid';
    }

    if (!fields['comment']) {
      errors['comment'] = 'This field is required';
    }

    this.setState({ errors: errors });
    return Object.keys(errors).length === 0;
  }

  componentDidMount() {
    this.fetchIps();
  }

  calculateOffset() {
    const elementHeight = this.tableRef.current.getBoundingClientRect().top;
    return window.innerHeight - elementHeight;
  }

  changeNewIpOption = (name, e) => {
    let fields = this.state.fields;
    fields[name] = e.target.value;

    this.setState({
      fields,
    });
  };

  fetchIps = () => {
    this.setState({
      isLoading: true,
    });

    whitelistService.getIps(null).then((data) => {
      this.setState({
        ips: data.ips,
        isLoading: false,
      });
    });
  };

  createOrUpdateId = (event) => {
    event.preventDefault();

    if (this.handleValidation()) {
      let fields = {};
      Object.keys(this.state.fields).map((key) => {
        fields[key] = '';
      });

      this.setState({
        addingIp: true,
      });

      if (this.state.editingIp) {
        return this.updateIp(this.state.editingId, fields);
      }

      return this.createIp(fields);
    } else {
      this.setState({ addingIp: false, showAddIpForm: true });
    }
  };

  createIp = (fields) => {
    whitelistService
      .addIp(this.state.fields.ip, this.state.fields.comment)
      .then(() => {
        toast.success('IP has been added to whitelist', {
          position: 'top-center',
        });
        this.fetchIps();
        this.setState({
          addingIp: false,
          editingIp: false,
          editingId: null,
          showAddIpForm: false,
          fields: fields,
        });
      })
      .catch(({ error }) => {
        toast.error(error, { position: 'top-center' });
        this.setState({ addingIp: false });
      });
  };

  updateIp = (ip, fields) => {
    whitelistService
      .updateIp(this.state.editingId, this.state.fields.ip, this.state.fields.comment)
      .then(() => {
        toast.success('Ip has been updated.', {
          position: 'top-center',
        });
        this.fetchIps();
        this.setState({
          addingIp: false,
          editingIp: false,
          editingId: null,
          showAddIpForm: false,
          fields: fields,
        });
      })
      .catch(({ error }) => {
        toast.error(error, { position: 'top-center' });
        this.setState({ removingIp: null });
      });
  };

  removeIp = (id) => {
    this.setState({ removingIp: id });

    whitelistService
      .removeIp(id)
      .then(() => {
        toast.success('Ip has been removed from whitelist', {
          position: 'top-center',
        });
        this.setState({ removingIp: null });
        this.fetchIps();
      })
      .catch(({ error }) => {
        toast.error(error, { position: 'top-center' });
        this.setState({ removingIp: null });
      });
  };

  restoreIp = (id) => {
    this.setState({ restoringIp: id });

    whitelistService
      .restoreIp(id)
      .then(() => {
        toast.success('Ip has been restored from whitelist', {
          position: 'top-center',
        });
        this.setState({ restoringIp: null });
        this.fetchIps();
      })
      .catch(({ error }) => {
        toast.error(error, { position: 'top-center' });
        this.setState({ restoringIp: null });
      });
  };

  render() {
    const { isLoading, ips, showAddIpForm, addingIp, restoringIp, removingIp } = this.state;
    return (
      <div className="wrapper ip-whitelist-page">
        <Header switchDarkMode={this.props.switchDarkMode} darkMode={this.props.darkMode} />
        <ReactTooltip type="dark" effect="solid" delayShow={250} />

        <div className="page-wrapper">
          <div className="container-xl">
            <div className="page-header d-print-none">
              <div className="row align-items-center">
                <div className="col">
                  <div className="page-pretitle"></div>
                  <h2 className="page-title" data-cy="whitelist-page-title">
                    IP Whitelist
                  </h2>
                </div>
                <div className="col-auto ms-auto d-print-none">
                  {!showAddIpForm && (
                    <div
                      className="btn btn-primary"
                      onClick={() =>
                        this.setState({
                          showAddIpForm: true,
                          editingIp: false,
                          editingId: null,
                          fields: {
                            ip: '',
                            comment: '',
                          },
                        })
                      }
                      data-cy="add-new-ip"
                    >
                      Add new IP Address to whitelist
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="page-body">
            {showAddIpForm && (
              <div className="container-xl">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title" data-cy="add-new-user">
                      {this.state.editingIp ? 'Edit whitelist record' : 'Add new whitelist record'}
                    </h3>
                  </div>
                  <div className="card-body">
                    <form onSubmit={this.createOrUpdateId} noValidate>
                      <div className="form-group mb-3 ">
                        <div className="row">
                          <div className="col">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter IP address (ex. 192.168.0.0/25)"
                              name="ip"
                              onChange={this.changeNewIpOption.bind(this, 'ip')}
                              value={this.state.fields['ip']}
                              data-cy="ip-input"
                            />
                            <span className="text-danger" data-cy="ip-error">
                              {this.state.errors['ip']}
                            </span>
                          </div>
                          <div className="col">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter comment"
                              name="comment"
                              onChange={this.changeNewIpOption.bind(this, 'comment')}
                              value={this.state.fields['comment']}
                              data-cy="comment-input"
                            />
                            <span className="text-danger" data-cy="comment-error">
                              {this.state.errors['comment']}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="form-footer">
                        <button
                          type="button"
                          className="btn btn-light mr-2"
                          onClick={() =>
                            this.setState({
                              showAddIpForm: false,
                              editingIp: false,
                              newIp: {},
                            })
                          }
                          data-cy="cancel-button"
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className={`btn mx-2 btn-primary ${addingIp ? 'btn-loading' : ''}`}
                          disabled={addingIp}
                          data-cy="add-ip-button"
                        >
                          {this.state.editingIp ? 'Update Whitelist IP' : 'Add IP to Whitelist'}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            )}
            {!showAddIpForm && (
              <div className="container-xl">
                <div className="card">
                  <div
                    className="card-table fixedHeader table-responsive table-bordered"
                    ref={this.tableRef}
                    style={{
                      maxHeight: this.tableRef.current && this.calculateOffset(),
                    }}
                  >
                    <table data-testid="ipsTable" className="table table-vcenter" disabled={true}>
                      <thead>
                        <tr>
                          <th data-cy="comment-title">Comment</th>
                          <th data-cy="ip-title">IP Address</th>
                          <th data-cy="created-at-title">Created at</th>
                          <th data-cy="status-title">Status</th>
                          <th className="w-1"></th>
                        </tr>
                      </thead>
                      {isLoading ? (
                        <tbody className="w-100" style={{ minHeight: '300px' }}>
                          {Array.from(Array(5)).map((_item, index) => (
                            <tr key={index}>
                              <td className="col-2 p-3">
                                <div className="row">
                                  <div className="skeleton-line w-10 col mx-3"></div>
                                </div>
                              </td>
                              <td className="col-4 p-3">
                                <div className="skeleton-line w-10"></div>
                              </td>
                              <td className="col-4 p-3">
                                <div className="skeleton-line w-10"></div>
                              </td>
                              <td className="text-muted col-auto col-1 pt-3">
                                <div className="skeleton-line"></div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      ) : (
                        <tbody>
                          {ips.map((ip) => (
                            <tr key={ip.id}>
                              <td>
                                <span
                                  className="mx-3"
                                  style={{
                                    display: 'inline-flex',
                                    marginBottom: '7px',
                                  }}
                                  data-cy="ip-comment"
                                >
                                  {ip.comment}
                                </span>
                              </td>
                              <td className="text-muted">
                                <a className="text-reset user-email" data-cy="user-email">
                                  {ip.address}
                                </a>
                              </td>
                              <td className="text-muted">
                                <a className="text-reset user-email" data-cy="created-at">
                                  {new Date(ip.created_at).toLocaleString('en-GB')}
                                </a>
                              </td>
                              <td className="text-muted">
                                <span
                                  className={`badge bg-${ip.deleted ? 'warning' : 'success'} me-1 m-1`}
                                  data-cy="status-badge"
                                ></span>
                                <small className="ip-deleted" data-cy="user-status">
                                  {ip.deleted ? 'Deleted' : 'Active'}
                                </small>
                              </td>
                              <td>
                                <button
                                  type="button"
                                  style={{ minWidth: '100px' }}
                                  className={`btn btn-sm`}
                                  onClick={() => {
                                    this.setState({
                                      showAddIpForm: true,
                                      editingIp: true,
                                      editingId: ip.id,
                                      fields: {
                                        ip: ip.address,
                                        comment: ip.comment,
                                      },
                                    });
                                  }}
                                  data-cy="user-state"
                                >
                                  Edit
                                </button>
                                <button
                                  type="button"
                                  style={{ minWidth: '100px' }}
                                  className={`btn btn-sm btn-outline-${ip.deleted ? 'success' : 'danger'} ${
                                    restoringIp === ip.id || removingIp === ip.id ? 'btn-loading' : ''
                                  }`}
                                  disabled={restoringIp === ip.id || removingIp === ip.id}
                                  onClick={() => {
                                    ip.deleted ? this.restoreIp(ip.id) : this.removeIp(ip.id);
                                  }}
                                  data-cy="user-state"
                                >
                                  {ip.deleted ? 'Restore' : 'Delete'}
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      )}
                    </table>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
export { ManageWhitelist };
